<script>
import GlobalVue from '@helper/Global.vue';
import Gen from '@helper/Gen';
import BOGen from '@helper/BOGen';
import PageTitle from '@backend/part/PageTitle.vue';
import swal from 'sweetalert';
import EventBus from '@root/helper/EventBus';

export default {
  extends:GlobalVue,
  components:{PageTitle},
  data(){
    return {
			Name: "",
      PageName: "",
      ObjectName: "",
			AddItem: false,
			data: {data:false},
			Sorting: false,
      filter: {
        limit : 50
      },
      row:{},
      mrValidation:{},
      ajaxRefreshData: null,
    }
	},
  computed:{
    NotFound(){
      if(this.data.data === false) return false
      if(this.data.data.length > 0) return false
      if(this.$route.query.search){
        return "Search with keyword '"+this.$route.query.search+"' not found"
      }
      return this.ObjectName+" is empty"
    },
  },
  mounted(){    
    if(!this.$root.user.bu_id) this.refreshUser()

    setTimeout(()=>{ $(window).trigger("resize") }, 300)
    this.$root.user = Gen.getCookie("user")

    // Set filter
    this.$set(this, 'filter', Object.assign(Gen.clone(this.filter), Gen.clone(this.$route.query)));
    if(this.WithLimit) this.filter.limit = Gen.getCookie("pagelimit", 50)
    
    // Get Bo Metainfo
    /* if(this.Name){
      this.refreshData(null, {metainfo:true})
    } */

    // Logout Callback
    EventBus.$off("logout")
    EventBus.$on("logout", ()=>{
      this.logout()
    })

    this.getInboxData()
  },
  methods:{
    /* Set Name Using Route */
    setNameRoute(){
      this.Name = this.$route.name
    },
    /* Helper Methods */
    apiPost(type, data, cb){
      BOGen.apirest("/"+this.Name, Object.assign({type:type}, data), cb, "POST")
    },
    /* To Route Function */
    redirectToList(){
      this.$router.push({name:this.Name})
    },
    redirectToCrud(id="add"){
      this.$router.push({name:this.Name,params:{id:id}})
    },
    getInboxData(){
      const routeName = this.$route.name      
      BOGen.apirest(`/Inbox`, {route_name: routeName}, (err, resp)=>{
        let data = resp.data.data
        var inboxMenu = $("[href='/inbox']")
        if(data.length){
          inboxMenu.html("<div class='inbox-pointer'></div><i class='ti-email'></i> <span class='hide-menu'>Inbox</span>")
        } else{
          inboxMenu.html("<i class='ti-email'></i> <span class='hide-menu'>Inbox</span>")
        }
      })
    },
    refreshUser(){
      if(!Gen.getCookie('botk')) return;
      BOGen.apirest("/profile", {}, (err, resp)=>{
        if(err) if(err.status == 401){
          return this.logout()
        }
        Gen.putCookie("user", resp.user)
        this.$root.user = resp.user
      })
    },
    refreshData(param = {}){
      this.data.data = false
      
      if(!this.$route.params.id && this.$route.name == "AuditTrail"){
        this.filter.level = this.user.access_level
        this.filter.msg_id = this.user.msg_id
      }

      var params = Object.assign(param, Gen.clone(this.$route.query),Gen.clone(this.filter))
      if(params.startdate) params.startdate = moment(params.startdate, 'DD-MM-YYYY').format("YYYY-MM-DD") 
      if(params.enddate) params.enddate = moment(params.enddate, 'DD-MM-YYYY').format("YYYY-MM-DD") 
      if(params.effective_startdate) params.effective_startdate = moment(params.effective_startdate, 'DD-MM-YYYY').format("YYYY-MM-DD")
      if(params.effective_enddate) params.effective_enddate = moment(params.effective_enddate, 'DD-MM-YYYY').format("YYYY-MM-DD")
      
      var id = isNaN(this.$route.params.id) ? this.$route.params.id : this.$route.params.id;
     
      if(this.$route.params.id){
        this.loadingOverlay = true
      }

      this.ajaxRefreshData = BOGen.apirest("/"+this.Name+(this.$route.params.id?"/"+id:""), params, (err, resp)=>{        
        if(err){
          if(err.responseJSON.message=="No Permission"){
            this.$router.push({name:"Dashboard"})
          }
          if(this.onRefreshPage) return this.onRefreshPage(err, null)
          return;
        }
        Object.keys(resp).forEach((k)=>{
          this[k] = resp[k]
        })
        
        if(param.callback) param.callback(resp)

        if(this.$route.params.id){
          this.row.type = this.$route.params.id == "add" ? "add" : "update"
          this.loadingOverlay = false
        }
        if(this.onRefreshPage) return this.onRefreshPage(err, resp)
     
        // validate movement
        if(this.$route.params.id && this.$route.name == "MovementList"){
          if(this.user.access_level == 1){
            return 
          } else if(this.row.ai_created_by == this.user.cwid){
            return 
          } else if(this.row.aa.aa_manager_cwid == this.user.cwid){
            return 
          } else if(this.row.aa.aa_nmanager_cwid == this.user.cwid){
            return
          } else {
            this.$router.push({name : "Dashboard"})
          }
        }
      })
    },
    submitForm(e, callback){
      if(e&&e.btnLoading()) return;
      BOGen.apirest("/"+this.Name, this.row, (err, resp)=>{
        if(e) e.btnUnloading()
        if(err){
          if(err.status == 422){
            Object.keys(err.responseJSON).forEach((k)=>{
              $("[error="+k+"]").html("<label class='error'>"+err.responseJSON[k][0]+"</label>")
            })
          }
          if(err.status == 400){
            if(err.json.message) Gen.info(err.json.message, 'danger')
          }
          return
        }

        if(this.successFormCallback) return this.successFormCallback(resp);
        if(callback) return callback(resp);
        return Gen.info(resp.message, "success", 1000).then(()=>{
          this.row = {}
          this.$router.push({name:this.Name})
        })
      },"POST")
    },
    /* List Data Function */
    onPaging(page = 1){
      if($(".page-item.active").text() == page) return;
      this.$router.push({name:this.Name, query: Object.assign(Gen.clone(this.$route.query),{page:page})})
    },
    search(){
      var query = Object.assign(Gen.clone(this.$route.query),Gen.clone(this.filter))
      delete query.page
      this.$router.push({name:this.Name, query: query})
    },
    resetSearch(){
      this.filter = {}
      this.$router.push({name:this.Name})
    },
    changeStatus(k){
      var v = this.data.data[k]      
      var text = !this.statusKey ? (v.status==true?"Inactive":"Active") : (v[this.statusKey]==true?"Inactive":"Active")
      swal({
        title: "Are you sure to "+text+"?",
        text:"",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, "+text+"!"],
        // dangerMode: true,
      }).then((ok) => {
        if (ok) {
          v.status = v.status == true ? false : true
          if(this.statusKey) { 
            v.status = v[this.statusKey] ? false : true
            v[this.statusKey] = v[this.statusKey] ? false : true
          }
          BOGen.apirest("/"+this.Name+"/change-status", {id:v.id,status:v.status},()=>{
            // callback change status
            swal("Success!", "Status " + this.ObjectName + " has been changed.", "success");
          }, "POST")
        }
      });
    },
    deleteItem(e,k){
      var v = this.data.data[k]
      swal({
        title: "Are you sure to delete "+this.ObjectName+"?",
        text:"",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, Sure!"],
        dangerMode: true,
      }).then((ok) => {
        if (ok) {
          BOGen.apirest("/"+this.Name+"/delete", {id:v.id},(err,resp)=>{
            if(err){
              if(err.status==400){
                Gen.info(err.json.message, "")
                swal(err.json.title || "Information!", err.json.message, "warning");
              }
              return;
            }
            // callback delete item
            $(e.target).parents('tr').addClass("animated bounceOutRight");
            setTimeout(()=>{
              $(e.target).parents('tr').removeClass("animated bounceOutRight");
              this.data.data.splice(k, 1);
              this.data.total--
            }, 1000);
            swal("Information!", this.ObjectName + " has been deleted.", "success");
          }, "POST")
        }
      });
    },
		onSort(){
      var sorting = []
      this.data.data.forEach(v=>{
        sorting.push({id:v.id,sort:v.sort});
      })
      BOGen.apirest("/"+this.Name+"/sorting", {sorting:sorting}, (err, resp)=>{
        if(err) return console.error(err);
      }, "POST")
		},
    /* MenuRole */
    menuRole(name = ""){
      if(this.user.bu_level == 0) return true
      return this.user.menuRole.indexOf(name) > -1
    },
    moduleRole(name = ""){
      if(this.user.bu_level == 0) return true
      return this.user.moduleRole.indexOf(name) > -1
    },
    /* Logout */
    logout(){
      Gen.putCookie("user")
      Gen.putCookie("botk")
      this.$router.push({name:"Login"})
    },
    changeLimit(){
      if(!this.filter.limit) return this.filter.limit = 50;
      Gen.putCookie("pagelimit", this.filter.limit)
      this.search()
    },
    filterStatus(){
      this.search()
    },
  },
  beforeDestroy(){
    if(this.ajaxRefreshData) this.ajaxRefreshData.abort()
  },
  watch:{
    '$route.query'(v){
      this.filter = Gen.clone(v)
      if(!this.filter.limit && !this.$route.params.id) this.filter.limit = 50
      this.getInboxData()
    },
    'filter.limit'(v){
      if(!v) return this.filter.limit = 50;
      Gen.putCookie("pagelimit", v)
      this.search()
    },
  }
}
</script>
